import * as React from "react";
import { useState, useEffect, useLayoutEffect, useRef, useMemo } from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import GroupsIcon from "@mui/icons-material/Groups";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReduceCapacityIcon from "@mui/icons-material/ReduceCapacity";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import EngineeringIcon from "@mui/icons-material/Engineering";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import CelebrationIcon from "@mui/icons-material/Celebration";
import HistoryIcon from '@mui/icons-material/History';
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ScheduleIcon from "@mui/icons-material/Schedule";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SearchIcon from "@mui/icons-material/Search";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import PaletteIcon from '@mui/icons-material/Palette';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme as useAppTheme, ACCENT_COLORS, ACCENT_SOLID_HEX } from '../../contexts/ThemeContext';

import {
    Button,
    Autocomplete,
    Popover,
    TextField,
    AppBar,
    Box,
    CssBaseline,
    Divider,
    Drawer,
    Tooltip,
    Avatar,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
    Chip,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Draggable from "react-draggable";
import MenuIcon from "@mui/icons-material/Menu";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";

import NavVariant from "./NavVariants";
import { usePath } from "./PathContext";
import { useSearchContext } from "../../Context/SearchContext";
import { useMenuLayout } from "../../contexts/MenuLayoutContext";
import {
    AutocompleteMember,
} from "../Apihelper/MemberApiHelpr";
// import "./Sidebar.css"; // Removed the external CSS import

const drawerWidth = 260;

// Built per-render from the selected accent color (see ThemeContext) instead
// of a fixed value, so the sidebar/app-bar/avatar follow the user's theme
// choice everywhere Header is rendered (i.e. every page).
const buildModernTheme = (colors) => createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: colors.evergreen,
            light: colors.leaf,
            dark: colors.evergreen,
            contrastText: '#fff',
        },
        secondary: {
            main: '#757575',
            light: '#a4a4a4',
            dark: '#494949',
            contrastText: '#fff',
        },
        background: {
            default: '#f8f9fa',
            paper: colors.evergreen,
        },
        text: {
            primary: colors.evergreen,
            secondary: '#757575',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.evergreen,
                    color: '#ffffff',
                    borderBottom: 'none',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: colors.evergreen,
                    color: colors.evergreen,
                    borderRight: '1px solid rgba(0, 0, 0, 0.08)',
                    '&.dark-mode': {
                        backgroundColor: '#1a1a1a',
                        color: '#ffffff',
                        borderRight: '1px solid rgba(255, 255, 255, 0.08)',
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    margin: '4px 12px',
                    padding: '10px 16px',
                    transition: 'all 0.2s ease-in-out',
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                        color: '#1a1a1a',
                        fontWeight: 500,
                        '& .MuiListItemIcon-root': {
                            color: '#1a1a1a',
                        },
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                    '&.dark-mode': {
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(255, 255, 255, 0.08)',
                            color: '#ffffff',
                            '& .MuiListItemIcon-root': {
                                color: '#ffffff',
                            },
                        },
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        },
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: '#6c757d',
                    minWidth: '32px',
                    transition: 'color 0.2s ease-in-out',
                    '&.dark-mode': {
                        color: '#a4a4a4',
                    },
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.leaf,
                    color: '#ffffff',
                    fontWeight: 600,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        '& input': {
                            padding: '8px 12px',
                            fontSize: '0.875rem',
                        },
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(108, 117, 125, 0.2)',
                    },
                    '&.dark-mode': {
                        '& .MuiInputBase-root': {
                            backgroundColor: '#2a2a2a',
                            '& input': {
                                color: '#ffffff',
                            },
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(255, 255, 255, 0.2)',
                        },
                    },
                },
            },
        },
    },
});

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const StyledTypography = styled(Typography)(({ theme }) => ({
    fontFamily: "'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 400,
    fontSize: '1rem',
    color: theme.palette.text.primary,
    letterSpacing: '0.2px',
    display: 'flex',
    flexWrap: 'wrap',
}));

const PremiumPopover = styled(Popover)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: '12px',
        padding: theme.spacing(2),
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: theme.palette.background.paper,
        minWidth: 260,
        color: theme.palette.text.primary,
    },
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    textTransform: 'none',
    borderRadius: '12px',
    fontSize: '0.9rem',
    padding: '12px 24px',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
        transform: 'scale(1.03)',
    },
    '&:active': {
        transform: 'scale(1)',
    },
}));

const StyledPremiumTypography = styled(Typography)(({ theme }) => ({
    fontFamily: "'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 600,
    fontSize: '1.2rem',
    color: theme.palette.secondary.main,
    letterSpacing: '0.1px',
    display: 'inline-block',
    position: 'relative',
    paddingBottom: 6,
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '0',
        height: '2px',
        width: '100%',
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.7,
    },
}));

const AbstractText = ({ text }) => {
    return (
        <StyledPremiumTypography variant="h6" component="div">
            {text}
        </StyledPremiumTypography>
    );
};

const StyledListItemButton = styled(ListItemButton, { shouldForwardProp: (prop) => prop !== 'active' })(({ theme, active }) => ({
    backgroundColor: active ? 'rgba(121, 85, 72, 0.1)' : 'transparent',
    color: theme.palette.text.primary,
    borderRadius: '12px',
    margin: '6px 12px',
    padding: '10px 18px',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    fontWeight: active ? 500 : 400,
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
        transform: 'translateX(2px)',
    },
    '&:active': {
        transform: 'translateX(0)',
    },
    ...(active && {
        color: theme.palette.primary.main,
        '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
        },
    }),
}));

const StyledListItemIcon = styled(ListItemIcon, { shouldForwardProp: (prop) => prop !== 'active' })(({ theme, active }) => ({
    color: active ? theme.palette.primary.main : theme.palette.text.secondary,
    minWidth: '36px',
    transition: 'color 0.3s ease',
    fontSize: '1.1rem'
}));

const StyledLogoutButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    borderRadius: '12px',
    padding: '12px 24px',
    fontSize: '0.9rem',
    fontWeight: 500,
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.error.dark,
        transform: 'scale(1.03)',
    },
    '&:active': {
        transform: 'scale(1)',
    },
}));

const ThinScrollBar = () => {
    return (
        <style global jsx>{`
          * {
            scrollbar-width: thin;
            scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
          }
          *::-webkit-scrollbar {
            width: 6px;
          }
          *::-webkit-scrollbar-track {
            background: transparent;
          }
          *::-webkit-scrollbar-thumb {
            background-color: rgba(155, 155, 155, 0.5);
            border-radius: 10px;
            border: transparent;
          }
        `}</style>
    );
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#ffffff',
    color: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.main,
    // ...
}));

const LAYOUT_ICONS = { sidebar: ViewSidebarIcon, dark: ViewSidebarIcon, tiles: ViewSidebarIcon, rail: ViewSidebarIcon, taskbar: ViewAgendaIcon };
const LAYOUT_LABELS = { sidebar: 'Classic (current)', dark: 'Dark minimal', tiles: 'Tiles', rail: 'Icon rail', taskbar: 'Taskbar' };

// Each page mounts its own Header, so the sidebar would restart at the top on every click; remember where it was.
let sidebarScrollTop = 0;
let sidebarRestoreUntil = 0; // scroll events caused by the list being rebuilt must not overwrite the remembered position
let sidebarLogsOpen = false; // whether the Logs group was open, so the next page draws the sidebar at the same height
// The menu list is drawn in several drawers (desktop, mobile); only one of them is on screen.
const visibleSideList = () =>
    [...document.querySelectorAll('[data-side-list]')].find((l) => l.clientHeight > 0) || null;

function ResponsiveDrawer(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const { setCurrentPath } = usePath();
    const { window } = props;
    const { menuLayout, setMenuLayout, sidebarWidth } = useMenuLayout();
    const [layoutMenuAnchor, setLayoutMenuAnchor] = useState(null);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const pathName = useLocation().pathname;
    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const { searchValuecontext, setSearchValuecontex } = useSearchContext();
    const [options, setOptions] = useState([]);
    // Autocomplete only stores display strings ("Name | ID | phone | email");
    // this keeps the member's real id alongside each string so picking a
    // suggestion can jump to that exact member instead of re-searching by name.
    const optionIdMapRef = useRef({});
    // Read straight away: filling it in an effect drew the sidebar empty for a moment on every page.
    const [user, setUser] = useState(() => {
        try {
            const stored = localStorage.getItem('userdata');
            return stored ? JSON.parse(stored) : null;
        } catch (e) {
            return null;
        }
    });
    const drawerRef = useRef(null);
    const listRef = useRef(null);
    const [activeItemIndex, setActiveItemIndex] = useState(null);
    const [logsOpen, setLogsOpen] = useState(sidebarLogsOpen); // the "Logs" group in the sidebar
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false); // phone: the search icon swaps the title for the search box
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('darkMode');
        return savedTheme ? JSON.parse(savedTheme) : false;
    });
    const { accentColor, setAccentColor, colors } = useAppTheme();
    const [colorMenuAnchor, setColorMenuAnchor] = useState(null);
    const modernTheme = useMemo(() => buildModernTheme(colors), [colors]);

    useEffect(() => {
        const storedUserData = localStorage.getItem('userdata');
        if (storedUserData) {
            setUser(JSON.parse(storedUserData));
        }
    }, []);

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [isDarkMode]);

    useEffect(() => {
        if (menuLayout === 'taskbar') {
            document.body.style.paddingBottom = '56px';
        } else {
            document.body.style.paddingBottom = '';
        }
        return () => { document.body.style.paddingBottom = ''; };
    }, [menuLayout]);

    const userInitial = user?.name?.charAt(0).toUpperCase() || 'G';
    const userColor = user?.user_color || modernTheme.palette.primary.main;

    const allMenuItems = [
        { name: "dashboard",      icon: <DashboardIcon />,      routes: ["dashboard","dashboard-next"],                                     adminOnly: false },
        { name: "follow up",      icon: <PersonSearchIcon />,    routes: ["Followup-visitors"],                                              adminOnly: false },
        { name: "members",        icon: <GroupsIcon />,          routes: ["memberlist","memberdetails","newmember"],                          adminOnly: false },
        { name: "offers",         icon: <LocalOfferIcon />,      routes: ["ParentOfferPackage","addnonmember","addofferpackage"],              adminOnly: false },
        { name: "due users",      icon: <ReduceCapacityIcon />,  routes: ["listdueusers"],                                                    adminOnly: false },
        { name: "balance",        icon: <AccountBalanceIcon />,  routes: ["balance-sheet"],                                                   adminOnly: false },
        { name: "attendance",     icon: <EventAvailableIcon />,  routes: ["attendance-sheet"],                                                adminOnly: false },
        { name: "packages",       icon: <Inventory2Icon />,      routes: ["managepackage"],                                                   adminOnly: false },
        { name: "staff",          icon: <EngineeringIcon />,     routes: ["employeesdetail","addemployees","monthly-attendance"],             adminOnly: false },
        { name: "holidays",       icon: <CelebrationIcon />,     routes: ["holiday-calendar"],                                                adminOnly: false },
        { name: "pt",             icon: <CardMembershipIcon />,  routes: ["trainer-wise-member"],                                             adminOnly: false },
        { name: "users",          icon: <ManageAccountsIcon />,  routes: ["userlist","adduser"],                                              adminOnly: true  },
        { name: "bulk whatsapp",  icon: <WhatsAppIcon />,        routes: ["bulk-holiday-whatsapp"],                                           adminOnly: false },
        { name: "diet",           icon: <RestaurantIcon />,      routes: ["diet-chart"],                                                      adminOnly: false },
        { name: "exercise",       icon: <FitnessCenterIcon />,   routes: ["exercise-list","create-exercise","exercise-assign-user"],          adminOnly: false },
        { name: "expense",        icon: <ReceiptLongIcon />,     routes: ["expense-list"],                                                    adminOnly: false },
        { name: "operation logs", icon: <HistoryIcon />,         routes: ["operation-logs"],                                                  adminOnly: true  },
        { name: "device logs",    icon: <DevicesOtherIcon />,    routes: ["device-command-logs"],                                             adminOnly: true  },
        { name: "message logs",   icon: <NotificationsActiveIcon />, routes: ["notification-logs"],                                            adminOnly: true  },
        { name: "cron logs",      icon: <ScheduleIcon />,            routes: ["cron-logs"],                                                    adminOnly: true  },
    ];

    const isAdmin = user?.role === 'admin';
    const pageAccess = Array.isArray(user?.page_access) ? user.page_access.map(p => p.toLowerCase()) : null;

    const menuItems = allMenuItems.filter(item => {
        if (isAdmin) return true;
        // No explicit page_access list → fall back to the adminOnly default.
        // With an explicit list, granted access overrides adminOnly so admins
        // can selectively hand out access to admin-only pages like this.
        if (pageAccess === null) return !item.adminOnly;
        return pageAccess.includes(item.name.toLowerCase());
    });

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const isActive = (routes = []) => {
        const currentPath = location.pathname.replace(/^\/+/, '');
        return routes.includes(currentPath);
      };

    // The four log pages are shown together under one expandable "Logs" entry (declared after isActive, which it uses).
    const LOG_NAMES = ["operation logs", "device logs", "message logs", "cron logs"];
    const isLogItem = (item) => LOG_NAMES.includes(item.name);
    const logItems = menuItems.filter(isLogItem);
    const topItemCount = menuItems.length - logItems.length; // the log items are last in the list
    const logsActive = logItems.some((item) => isActive(item.routes));

      
      
    const handleAutocompleteChange = async (value) => {
        setSearchValuecontex(value);
        if (value.length >= 3) {
            try {
                const userData = localStorage.getItem('userdata');
                const userDataObj = JSON.parse(userData);
                const userToken = userDataObj.token;
                const userId = userDataObj.id;
                const searchText = value;

                const res = await AutocompleteMember(userToken, userId, searchText);

                if (res.code === 200 || res.code === "200") {
                    const list = Array.isArray(res.data) ? res.data : [];
                    const names = list.map(item => item.search_data);
                    const idMap = {};
                    list.forEach(item => { idMap[item.search_data] = item.id; });
                    optionIdMapRef.current = idMap;
                    setOptions(names);
                } else {
                    setOptions([]);
                    if (res.message) console.error("Autocomplete API Error:", res.message);
                }
            } catch (error) {
                console.error("Autocomplete Error:", error);
            }
        } else {
            setOptions([]);
        }
    };

    const handleSearchNavigate = (value) => {
        if (value) {
            const memberId = optionIdMapRef.current[value] ?? null;
            navigate(`/memberlist`, { state: { searchQuery: value, memberId } });
            setOptions([]);
        }
    };

    const handleSearchClear = () => {
        setSearchValuecontex('');
        setOptions([]);
        navigate('/memberlist', { state: { searchQuery: '' } });
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            const value = searchValuecontext;
            if (value && value.trim()) {
                navigate('/memberlist', { state: { searchQuery: value.trim() } });
                setOptions([]);
            }
        }
    };

    // The global search box should only ever display its text while on the
    // Member List page. Deriving this at render time (rather than relying
    // solely on an effect clearing the context) guarantees it can never show
    // stale text on Member Details or any other route, even for a frame.
    const isOnMemberListPage = location.pathname.replace(/^\/+/, '').toLowerCase() === 'memberlist';

    useLayoutEffect(() => {
        if (!isOnMemberListPage && searchValuecontext) {
            setSearchValuecontex('');
        }
    }, [isOnMemberListPage, searchValuecontext]);

    const handleOpenLogoutDialog = () => {
        setOpenLogoutDialog(true);
        setAnchorEl(null);
    };

    const handleCloseLogoutDialog = () => {
        setOpenLogoutDialog(false);
    };

    const handleLogout = () => {
        localStorage.removeItem('userdata');
        navigate('/', { replace: true });
        setOpenLogoutDialog(false);
    };

    const handleOpenAccountPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseAccountPopover = () => {
        setAnchorEl(null);
    };

    const isAccountPopoverOpen = Boolean(anchorEl);
    const accountPopoverId = isAccountPopoverOpen ? 'account-menu' : undefined;

    // Scroll sidebar so the active menu item is visible when route changes (e.g. after navigation)
    useEffect(() => {
        const found = menuItems.findIndex((item) => isActive(item.routes));
        const activeIndex = found >= 0 && isLogItem(menuItems[found]) ? topItemCount : found;
        if (activeIndex >= 0 && listRef.current?.children[activeIndex]) {
            const el = listRef.current.children[activeIndex];
            el.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'nearest' });
        }
    }, [pathName]);

    // Put the sidebar back where it was before this page replaced the previous one. The list can still be
    // growing for a moment (menu items, Logs group), so the position is held until it settles or the user scrolls.
    useLayoutEffect(() => {
        const el = visibleSideList();
        if (!el || !sidebarScrollTop) return undefined;
        const target = sidebarScrollTop;
        sidebarRestoreUntil = Date.now() + 700;
        let frame = 0;
        const apply = () => {
            el.style.scrollBehavior = 'auto';
            if (Math.abs(el.scrollTop - target) > 1) el.scrollTop = target;
            el.style.scrollBehavior = '';
            // not tall enough yet to hold the position: keep it out of sight rather than show it at the wrong place
            el.style.visibility = el.scrollTop < target - 1 ? 'hidden' : '';
        };
        const stop = () => {
            sidebarRestoreUntil = 0;
            cancelAnimationFrame(frame);
            el.style.visibility = '';
        };
        const tick = () => {
            if (Date.now() > sidebarRestoreUntil) { el.style.visibility = ''; return; }
            apply();
            frame = requestAnimationFrame(tick);
        };
        apply();
        frame = requestAnimationFrame(tick);
        el.addEventListener('wheel', stop, { once: true, passive: true });
        el.addEventListener('touchstart', stop, { once: true, passive: true });
        el.addEventListener('pointerdown', stop, { once: true });
        return () => {
            cancelAnimationFrame(frame);
            el.style.visibility = '';
            el.removeEventListener('wheel', stop);
            el.removeEventListener('touchstart', stop);
            el.removeEventListener('pointerdown', stop);
        };
    }, []);

    // The Logs group opens after mount; once its pages are drawn, bring the current one into view.
    useEffect(() => {
        if (!logsOpen || !logsActive) return undefined;
        const timer = setTimeout(() => {
            const list = visibleSideList();
            const item = list?.querySelector('[data-active-log="true"]');
            if (!list || !item) return;
            const box = list.getBoundingClientRect();
            const rect = item.getBoundingClientRect();
            if (rect.top < box.top || rect.bottom > box.bottom) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 500);
        return () => clearTimeout(timer);
    }, [logsOpen, logsActive]);

    useEffect(() => { sidebarLogsOpen = logsOpen; }, [logsOpen]);

    // Phone: put the cursor in the search box as soon as it opens.
    useEffect(() => {
        if (mobileSearchOpen) setTimeout(() => document.getElementById('search-members')?.focus(), 50);
    }, [mobileSearchOpen]);

    // Open the Logs group whenever one of its pages is the current page (also on a direct load).
    useEffect(() => {
        if (logsActive) setLogsOpen(true);
    }, [logsActive]);

    const handleThemeToggle = () => {
        const next = !isDarkMode;
        setIsDarkMode(next);
        localStorage.setItem('darkMode', JSON.stringify(next));
        if (next) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    };

    const drawer = (
        <div
            className={`mai_div_menu ${isDarkMode ? 'dark-mode' : ''}`}
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                background: isDarkMode
                    ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)'
                    : `linear-gradient(180deg, ${colors.evergreen} 0%, ${colors.pine} 100%)`,
                transition: 'background 0.3s ease',
            }}
            ref={drawerRef}
        >
            <Box sx={{ 
                padding: { xs: '12px 16px', sm: '14px 20px' },
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderBottom: isDarkMode ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(255,255,255,0.1)',
                background: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.1)',
            }}>
                <Box
                    component="img"
                    src={`${process.env.PUBLIC_URL || ''}/images/rectangle-9@2x.png`}
                    alt="Maa Tara Tarini Gym"
                    sx={{
                        height: { xs: 32, sm: 38 },
                        width: 'auto',
                        objectFit: 'contain',
                        mb: 0.75,
                        filter: isDarkMode ? 'brightness(1.05)' : 'none',
                    }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '0.8rem', sm: '0.875rem' },
                        color: isDarkMode ? '#f1f5f9' : '#ffffff',
                        letterSpacing: '0.02em',
                        transition: 'color 0.3s ease',
                        textAlign: 'center',
                        lineHeight: 1.2,
                    }}
                >
                    Maa Tara Tarini Gym
                </Typography>
            </Box>
            <List 
                ref={listRef}
                data-side-list="true"
                onScroll={(e) => { if (Date.now() > sidebarRestoreUntil) sidebarScrollTop = e.currentTarget.scrollTop; }}
                sx={{ 
                    padding: { xs: 1.5, sm: 2 },
                    flexGrow: 1, 
                    overflowY: 'auto', 
                    overflowX: 'hidden',
                    scrollBehavior: 'smooth',
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-track': { background: 'transparent' },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255,255,255,0.25)',
                        borderRadius: '10px',
                    },
                    '&:hover::-webkit-scrollbar-thumb': {
                        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.35)' : 'rgba(255,255,255,0.4)',
                    },
                    scrollbarWidth: 'thin',
                    scrollbarColor: isDarkMode ? 'rgba(255,255,255,0.25) transparent' : 'rgba(255,255,255,0.3) transparent',
                }}
            >
 {menuItems.map((item, index) => {
                    if (isLogItem(item)) return null; // shown inside the "Logs" group below
                    const active = isActive(item.routes);
                    return (
                        <ListItem 
                            key={item.name} 
                            disablePadding 
                            sx={{ mb: { xs: 0.2, sm: 0.3 } }}
                        >
                            <StyledListItemButton
                                onClick={() => {
                                    setActiveItemIndex(index);
                                    setSearchValuecontex('');
                                    setOptions([]);
                                    const element = listRef.current?.children[index];
                                    if (element) {
                                        element.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'nearest' });
                                    }
                                    navigate(`/${item.routes[0]}`);
                                }}
                                active={active}
                                sx={{
                                    position: 'relative',
                                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                    padding: { xs: '10px 14px', sm: '12px 16px' },
                                    margin: '3px 10px',
                                    borderRadius: '12px',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        transform: 'translateX(4px)',
                                        backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.07)',
                                    },
                                    ...(active && {
                                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : colors.leaf,
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
                                        '&:before': {
                                            content: '""',
                                            position: 'absolute',
                                            left: -12,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            height: '22px',
                                            width: '3px',
                                            backgroundColor: isDarkMode ? '#818cf8' : colors.gold,
                                            borderRadius: '0 3px 3px 0',
                                            transition: 'all 0.25s ease',
                                        }
                                    }),
                                    cursor: 'pointer',
                                }}
                            >
                                <StyledListItemIcon 
                                    active={active}
                                    sx={{
                                        minWidth: { xs: '36px', sm: '40px' },
                                        color: active
                                            ? (isDarkMode ? '#c7d2fe' : '#ffffff')
                                            : (isDarkMode ? '#94a3b8' : '#AFC1B7'),
                                        transition: 'color 0.25s ease',
                                        ...(active && {
                                            '& .MuiSvgIcon-root': { fontSize: '1.25rem' }
                                        }),
                                    }}
                                >
                                    {item.icon}
                                </StyledListItemIcon>
                                <ListItemText 
                                    primary={item.name} 
                                    sx={{
                                        margin: 0,
                                        '& .MuiListItemText-primary': {
                                            fontSize: { xs: '0.8125rem', sm: '0.875rem' },
                                            fontWeight: active ? 600 : 500,
                                            textTransform: 'capitalize',
                                            letterSpacing: '0.02em',
                                            color: active
                                                ? (isDarkMode ? '#e2e8f0' : '#ffffff')
                                                : (isDarkMode ? '#94a3b8' : '#AFC1B7'),
                                            transition: 'color 0.25s ease',
                                        }
                                    }}
                                />
                            </StyledListItemButton>
                        </ListItem>
                    );
                })}
                {logItems.length > 0 && (
                    <Box>
                        <ListItem disablePadding sx={{ mb: { xs: 0.2, sm: 0.3 } }}>
                            <StyledListItemButton
                                onClick={() => setLogsOpen((o) => !o)}
                                active={logsActive && !logsOpen}
                                aria-expanded={logsOpen}
                                sx={{
                                    position: 'relative',
                                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                    padding: { xs: '10px 14px', sm: '12px 16px' },
                                    margin: '3px 10px',
                                    borderRadius: '12px',
                                    backgroundColor: logsActive && !logsOpen ? (isDarkMode ? 'rgba(99,102,241,0.2)' : colors.leaf) : 'transparent',
                                    '&:hover': { transform: 'translateX(4px)', backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.07)' },
                                    cursor: 'pointer',
                                }}
                            >
                                <StyledListItemIcon
                                    active={logsActive}
                                    sx={{ minWidth: { xs: '36px', sm: '40px' }, color: logsActive ? (isDarkMode ? '#c7d2fe' : '#ffffff') : (isDarkMode ? '#94a3b8' : '#AFC1B7') }}
                                >
                                    <FactCheckIcon />
                                </StyledListItemIcon>
                                <ListItemText
                                    primary="logs"
                                    sx={{
                                        margin: 0,
                                        '& .MuiListItemText-primary': {
                                            fontSize: { xs: '0.8125rem', sm: '0.875rem' },
                                            fontWeight: logsActive ? 600 : 500,
                                            textTransform: 'capitalize',
                                            letterSpacing: '0.02em',
                                            color: logsActive ? (isDarkMode ? '#e2e8f0' : '#ffffff') : (isDarkMode ? '#94a3b8' : '#AFC1B7'),
                                        },
                                    }}
                                />
                                <ExpandMoreIcon
                                    sx={{
                                        color: isDarkMode ? '#94a3b8' : '#AFC1B7',
                                        transform: logsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.25s ease',
                                    }}
                                />
                            </StyledListItemButton>
                        </ListItem>
                        <Collapse in={logsOpen} timeout="auto" unmountOnExit>
                            <List disablePadding>
                                {logItems.map((item) => {
                                    const active = isActive(item.routes);
                                    return (
                                        <ListItem key={item.name} disablePadding sx={{ mb: 0.2 }}>
                                            <StyledListItemButton
                                                onClick={() => {
                                                    setSearchValuecontex('');
                                                    setOptions([]);
                                                    navigate(`/${item.routes[0]}`);
                                                }}
                                                active={active}
                                                data-active-log={active ? 'true' : undefined}
                                                sx={{
                                                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                                    padding: { xs: '8px 12px', sm: '9px 14px' },
                                                    margin: '2px 10px 2px 26px',
                                                    borderRadius: '10px',
                                                    backgroundColor: active ? (isDarkMode ? 'rgba(99,102,241,0.2)' : colors.leaf) : 'transparent',
                                                    '&:hover': { backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.07)' },
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <StyledListItemIcon
                                                    active={active}
                                                    sx={{ minWidth: '32px', color: active ? (isDarkMode ? '#c7d2fe' : '#ffffff') : (isDarkMode ? '#94a3b8' : '#AFC1B7'), '& .MuiSvgIcon-root': { fontSize: '1.1rem' } }}
                                                >
                                                    {item.icon}
                                                </StyledListItemIcon>
                                                <ListItemText
                                                    primary={item.name.replace(/ logs?$/, '')}
                                                    sx={{
                                                        margin: 0,
                                                        '& .MuiListItemText-primary': {
                                                            fontSize: { xs: '0.78rem', sm: '0.84rem' },
                                                            fontWeight: active ? 600 : 500,
                                                            textTransform: 'capitalize',
                                                            color: active ? (isDarkMode ? '#e2e8f0' : '#ffffff') : (isDarkMode ? '#94a3b8' : '#AFC1B7'),
                                                        },
                                                    }}
                                                />
                                            </StyledListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Collapse>
                    </Box>
                )}
            </List>
            {/* Sidebar user info + logout — single compact row */}
            <Box sx={{
                borderTop: '1px solid rgba(255,255,255,0.08)',
                background: 'rgba(0,0,0,0.22)',
                px: 1.5,
                py: 1.25,
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
            }}>
                <Avatar sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: colors.gold,
                    color: colors.evergreen,
                    fontSize: '0.8rem',
                    fontWeight: 700,
                    flexShrink: 0,
                }}>
                    {userInitial}
                </Avatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{
                        fontSize: '0.78rem',
                        fontWeight: 600,
                        color: '#ffffff',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.2,
                    }}>
                        {user?.name || user?.username || 'User'}
                    </Typography>
                    <Typography sx={{
                        fontSize: '0.65rem',
                        color: 'rgba(255,255,255,0.4)',
                        lineHeight: 1.3,
                    }}>
                        {user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : ''}
                    </Typography>
                </Box>
                <Tooltip title="Logout" placement="top">
                    <IconButton
                        onClick={handleOpenLogoutDialog}
                        size="small"
                        sx={{
                            color: '#ffffff',
                            backgroundColor: '#C0392B',
                            borderRadius: '8px',
                            width: 32,
                            height: 32,
                            flexShrink: 0,
                            '&:hover': {
                                backgroundColor: '#a93226',
                            },
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <LogoutIcon sx={{ fontSize: '1rem' }} />
                    </IconButton>
                </Tooltip>
            </Box>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    const navVariantEl = (
        <NavVariant
            variant={menuLayout}
            items={menuItems}
            isActive={isActive}
            onOpen={(item) => { setSearchValuecontex(''); setOptions([]); setMobileOpen(false); navigate(`/${item.routes[0]}`); }}
            onLogout={handleOpenLogoutDialog}
            user={user}
            initial={userInitial}
            colors={colors}
            dark={isDarkMode}
        />
    );

    return (
        <ThemeProvider theme={modernTheme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <ThinScrollBar />
                <AppBar
                    position="fixed"
                    elevation={0}
                    sx={{
                        width: { xs: '100%', sm: `calc(100% - ${sidebarWidth}px)` },
                        ml: { xs: 0, sm: `${sidebarWidth}px` },
                        backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
                        borderBottom: isDarkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid #E6E4DC',
                        transition: 'width 0.3s ease-in-out, margin-left 0.3s ease-in-out',
                    }}
                >
                    <Toolbar 
                        sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            minHeight: { xs: '56px', sm: '64px' },
                            px: { xs: 2, sm: 3 },
                        }}
                    >
                        <Box sx={{ display: { xs: mobileSearchOpen ? 'none' : 'flex', sm: 'flex' }, alignItems: 'center', flex: 1, minWidth: 0 }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                                sx={{
                                    mr: { xs: 0.5, sm: 2 },
                                    display: { xs: 'inline-flex', sm: menuLayout !== 'taskbar' ? 'inline-flex' : 'none' },
                                    color: isDarkMode ? '#ffffff' : colors.leaf,
                                }}
                        >
                            <MenuIcon />
                        </IconButton>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 }, minWidth: 0 }}>
                                <Box
                                    component="img"
                                    src={`${process.env.PUBLIC_URL || ''}/images/rectangle-9@2x.png`}
                                    alt="Maa Tara Tarini Gym"
                                    sx={{
                                        height: { xs: 28, sm: 40 },
                                        width: 'auto',
                                        flexShrink: 0,
                                        objectFit: 'contain',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: { xs: '0.9rem', sm: '1.1rem' },
                                        color: isDarkMode ? '#ffffff' : colors.leaf,
                                        lineHeight: 1.2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        minWidth: 0,
                                        maxWidth: 'none',
                                    }}
                                >
                                    Maa Tara Tarini Gym
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: { xs: 0.25, sm: 2 },
                                flexShrink: { xs: mobileSearchOpen ? 1 : 0, sm: 0 },
                                flex: { xs: mobileSearchOpen ? 1 : 'none', sm: 'none' },
                                minWidth: 0,
                            }}
                        >
                            <Tooltip title={`Menu: ${menuLayout} (click to change)`}>
                                <IconButton
                                    color="inherit"
                                    onClick={(e) => setLayoutMenuAnchor(e.currentTarget)}
                                    sx={{ display: { xs: 'none', sm: 'inline-flex' }, color: isDarkMode ? '#ffffff' : colors.leaf, '&:hover': { backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(14,42,31,0.06)' } }}
                                >
                                    {React.createElement(LAYOUT_ICONS[menuLayout] || ViewSidebarIcon, { fontSize: 'small' })}
                                </IconButton>
                            </Tooltip>
                            <Autocomplete
                                freeSolo
                                id="search-members"
                                sx={{ flex: { xs: mobileSearchOpen ? 1 : 'none', sm: 'none' }, minWidth: 0 }}
                                options={options}
                                value={isOnMemberListPage ? (searchValuecontext || null) : null}
                                filterOptions={(x) => x}
                                onInputChange={(event, value, reason) => {
                                    if (reason === 'clear') { handleSearchClear(); return; }
                                    handleAutocompleteChange(value);
                                }}
                                onChange={(event, value, reason) => {
                                    if (reason === 'clear') { handleSearchClear(); return; }
                                    handleSearchNavigate(value);
                                    setMobileSearchOpen(false);
                                }}
                                clearIcon={
                                    <Box sx={{
                                        width: 18, height: 18,
                                        borderRadius: '50%',
                                        bgcolor: isDarkMode ? 'rgba(255,255,255,0.25)' : colors.leaf,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.4)' : '#14532D' },
                                        transition: 'background-color 0.15s',
                                        flexShrink: 0,
                                    }}>
                                        <CloseIcon sx={{ fontSize: 12, color: '#fff' }} />
                                    </Box>
                                }
                                componentsProps={{
                                    paper: {
                                        sx: {
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #E6E4DC',
                                            borderRadius: '10px',
                                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                            mt: 0.5,
                                            '& .MuiAutocomplete-listbox': {
                                                padding: '4px',
                                                '& .MuiAutocomplete-option': {
                                                    color: '#1B2420',
                                                    fontSize: '0.875rem',
                                                    borderRadius: '6px',
                                                    '&:hover': { backgroundColor: colors.leafSoft },
                                                    '&[aria-selected="true"]': { backgroundColor: colors.leafSoft, color: colors.leaf },
                                                    '&.Mui-focused': { backgroundColor: colors.leafSoft },
                                                },
                                            },
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                        {...params}
                                      size="small"
                                      placeholder="Search Members"
                                      onKeyDown={handleSearchKeyDown}
                                        sx={{
                                            display: { xs: mobileSearchOpen ? 'block' : 'none', sm: 'block' },
                                            width: { xs: '100%', sm: '200px', md: '250px' },
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : '#F6F5F0',
                                                borderRadius: '10px',
                                                '&:hover': {
                                                    backgroundColor: isDarkMode ? 'rgba(255,255,255,0.12)' : '#EDEBE5',
                                                },
                                                '& input': {
                                                    color: isDarkMode ? '#ffffff' : '#1B2420',
                                                    '&::placeholder': {
                                                        color: isDarkMode ? 'rgba(255,255,255,0.5)' : '#5B6660',
                                                        opacity: 1,
                                                    }
                                                },
                                                '& fieldset': {
                                                    borderColor: isDarkMode ? 'rgba(255,255,255,0.15)' : '#E6E4DC',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: isDarkMode ? 'rgba(255,255,255,0.3)' : colors.leaf,
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: colors.leaf,
                                                }
                                            }
                                        }}
                                    />
                                )}
                            />
                            <IconButton
                                aria-label={mobileSearchOpen ? 'Close search' : 'Search members'}
                                sx={{
                                    display: { xs: 'flex', sm: 'none' },
                                    color: isDarkMode ? '#ffffff' : colors.leaf,
                                }}
                                onClick={() => setMobileSearchOpen((o) => !o)}
                            >
                                {mobileSearchOpen ? <CloseIcon /> : <SearchIcon />}
                            </IconButton>
                            <IconButton
                                color="inherit"
                                onClick={handleThemeToggle}
                                sx={{
                                    display: { xs: mobileSearchOpen ? 'none' : 'inline-flex', sm: 'inline-flex' },
                                    color: isDarkMode ? '#ffffff' : colors.leaf,
                                    '&:hover': {
                                        backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(14,42,31,0.06)',
                                    }
                                }}
                            >
                                {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                            </IconButton>
                            <Tooltip title="Theme color">
                                <IconButton
                                    color="inherit"
                                    onClick={(e) => setColorMenuAnchor(e.currentTarget)}
                                    sx={{
                                        display: { xs: mobileSearchOpen ? 'none' : 'inline-flex', sm: 'inline-flex' },
                                        color: isDarkMode ? '#ffffff' : colors.leaf,
                                        '&:hover': {
                                            backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(14,42,31,0.06)',
                                        }
                                    }}
                                >
                                    <PaletteIcon />
                                </IconButton>
                            </Tooltip>
                            <Popover
                                open={Boolean(colorMenuAnchor)}
                                anchorEl={colorMenuAnchor}
                                onClose={() => setColorMenuAnchor(null)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            >
                                <Box sx={{ p: 2, maxWidth: 240 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5, color: '#1B2420' }}>
                                        Theme Color
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25 }}>
                                        {ACCENT_COLORS.map((color) => {
                                            const isSelected = accentColor === color;
                                            return (
                                                <Tooltip title={color.charAt(0).toUpperCase() + color.slice(1)} key={color}>
                                                    <IconButton
                                                        onClick={() => setAccentColor(color)}
                                                        sx={{
                                                            width: 32,
                                                            height: 32,
                                                            bgcolor: ACCENT_SOLID_HEX[color],
                                                            border: isSelected ? '2px solid #1B2420' : '2px solid transparent',
                                                            '&:hover': { bgcolor: ACCENT_SOLID_HEX[color], opacity: 0.85 },
                                                        }}
                                                    >
                                                        {isSelected && <CheckIcon sx={{ color: '#fff', fontSize: 16 }} />}
                                                    </IconButton>
                                                </Tooltip>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            </Popover>
                            <Tooltip title="Account">
                                <IconButton
                                    size="small"
                                    aria-controls={accountPopoverId}
                                    aria-haspopup="true"
                                    onClick={handleOpenAccountPopover}
                                    sx={{ display: { xs: mobileSearchOpen ? 'none' : 'inline-flex', sm: 'inline-flex' } }}
                                >
                                    <Avatar 
                                        sx={{ 
                                            width: { xs: 35, sm: 40 }, 
                                            height: { xs: 35, sm: 40 },
                                            backgroundColor: colors.leaf,
                                            color: '#ffffff',
                                            transition: 'transform 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                            }
                                        }}
                                    >
                                        {userInitial}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                            <Popover
                                id={accountPopoverId}
                                open={isAccountPopoverOpen}
                                anchorEl={anchorEl}
                                onClose={handleCloseAccountPopover}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                sx={{
                                    mt: 1,
                                    '& .MuiPaper-root': {
                                        width: 300,
                                        borderRadius: '16px',
                                        boxShadow: '0 8px 32px rgba(14,42,31,0.18)',
                                        border: '1px solid rgba(31,122,84,0.12)',
                                        overflow: 'hidden',
                                        backgroundColor: '#ffffff',
                                    }
                                }}
                            >
                                {/* Green header band */}
                                <Box sx={{
                                    background: `linear-gradient(135deg, ${colors.evergreen} 0%, ${colors.leaf} 100%)`,
                                    px: 3,
                                    pt: 3,
                                    pb: 2.5,
                                    textAlign: 'center',
                                    position: 'relative',
                                }}>
                                    <Avatar
                                        sx={{
                                            width: 72,
                                            height: 72,
                                            mx: 'auto',
                                            mb: 1.5,
                                            backgroundColor: colors.gold,
                                            color: colors.evergreen,
                                            fontSize: '1.8rem',
                                            fontWeight: 700,
                                            border: '3px solid rgba(255,255,255,0.3)',
                                            boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
                                        }}
                                    >
                                        {userInitial}
                                    </Avatar>
                                    <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', color: '#ffffff', lineHeight: 1.2 }}>
                                        {user?.name || user?.username || 'User'}
                                    </Typography>
                                    {user?.role && (
                                        <Chip
                                            label={user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                                            size="small"
                                            sx={{
                                                mt: 0.75,
                                                backgroundColor: 'rgba(201,162,39,0.25)',
                                                color: colors.gold,
                                                border: '1px solid rgba(201,162,39,0.4)',
                                                fontWeight: 600,
                                                fontSize: '0.7rem',
                                                height: 22,
                                            }}
                                        />
                                    )}
                                </Box>

                                {/* Info section */}
                                <Box sx={{ px: 2.5, pt: 2, pb: 2 }}>
                                    <Box sx={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #E6E4DC',
                                        overflow: 'hidden',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    }}>
                                        {user?.email && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25, borderBottom: user?.phone ? '1px solid #F0EDE8' : 'none' }}>
                                                <Box sx={{ width: 30, height: 30, borderRadius: '8px', backgroundColor: colors.leafSoft, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <EmailIcon sx={{ fontSize: 15, color: colors.leaf }} />
                                                </Box>
                                                <Box sx={{ minWidth: 0 }}>
                                                    <Typography sx={{ fontSize: '0.65rem', color: '#5B6660', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Email</Typography>
                                                    <Typography sx={{ fontSize: '0.8rem', color: '#1B2420', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {user.email}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        )}
                                        {user?.phone && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25 }}>
                                                <Box sx={{ width: 30, height: 30, borderRadius: '8px', backgroundColor: colors.leafSoft, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <PhoneIcon sx={{ fontSize: 15, color: colors.leaf }} />
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ fontSize: '0.65rem', color: '#5B6660', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Phone</Typography>
                                                    <Typography sx={{ fontSize: '0.8rem', color: '#1B2420', fontWeight: 500 }}>
                                                        {user.phone}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                    <Button
                                        fullWidth
                                        onClick={handleOpenLogoutDialog}
                                        startIcon={<LogoutIcon />}
                                        sx={{
                                            mt: 2,
                                            backgroundColor: 'rgba(192,57,43,0.08)',
                                            color: '#C0392B',
                                            border: '1px solid rgba(192,57,43,0.2)',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            py: 1,
                                            borderRadius: '10px',
                                            '&:hover': {
                                                backgroundColor: 'rgba(192,57,43,0.15)',
                                                borderColor: 'rgba(192,57,43,0.4)',
                                            },
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        Sign Out
                                    </Button>
                                </Box>
                            </Popover>
                        </Box>
                    </Toolbar>
                </AppBar>
                {menuLayout !== 'taskbar' && (
                <Box
                    component="nav"
                    sx={{ 
                        width: { sm: drawerWidth }, 
                        flexShrink: { sm: 0 },
                    }}
                    aria-label="mailbox folders"
                >
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{ keepMounted: true }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { 
                                boxSizing: 'border-box', 
                                width: drawerWidth,
                                ...(menuLayout !== 'sidebar' && { backgroundImage: 'none', backgroundColor: menuLayout === 'dark' ? '#2b2b2a' : (isDarkMode ? '#1a1a1a' : '#ffffff') }),
                                borderRight: '1px solid rgba(31, 122, 84, 0.06)',
                                boxShadow: '0 0 0 1px rgba(0,0,0,0.03), 8px 0 32px rgba(0, 0, 0, 0.08)',
                            },
                        }}
                    >
                        {menuLayout === 'sidebar' ? drawer : navVariantEl}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            '& .MuiDrawer-paper': { 
                                boxSizing: 'border-box', 
                                width: drawerWidth,
                                borderRight: '1px solid rgba(31, 122, 84, 0.06)',
                                boxShadow: '0 0 0 1px rgba(0,0,0,0.02), 4px 0 24px rgba(0, 0, 0, 0.06)',
                                overflowX: 'hidden',
                                ...(menuLayout === 'sidebar'
                                    ? { '&:hover': { overflowY: 'auto' } }
                                    : {
                                        // the new styles scroll inside themselves and paint their own background
                                        overflowY: 'hidden',
                                        borderRight: 'none',
                                        backgroundImage: 'none',
                                        backgroundColor: menuLayout === 'dark' ? '#2b2b2a' : (isDarkMode ? '#1a1a1a' : '#ffffff'),
                                    }),
                            },
                        }}
                        open
                    >
                        {menuLayout === 'sidebar' ? drawer : navVariantEl}
                    </Drawer>
                </Box>
                )}
                {menuLayout === 'taskbar' && (
                    <Box
                        component="nav"
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: 56,
                            backgroundColor: isDarkMode ? '#1a1a1a' : colors.evergreen,
                            borderTop: '1px solid rgba(255,255,255,0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5,
                            overflowX: 'auto',
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            px: 1,
                            '&::-webkit-scrollbar': { height: 4 },
                        }}
                    >
                        {menuItems.map((item) => {
                            const active = isActive(item.routes);
                            return (
                                <Tooltip key={item.name} title={item.name}>
                                    <IconButton
                                        onClick={() => { setSearchValuecontex(''); setOptions([]); navigate(`/${item.routes[0]}`); }}
                                        sx={{
                                            color: active ? '#fff' : 'rgba(255,255,255,0.7)',
                                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
                                        }}
                                    >
                                        {item.icon}
                                    </IconButton>
                                </Tooltip>
                            );
                        })}
                        <Box sx={{ flex: 1, minWidth: 16 }} />
                        <Tooltip title="Logout">
                            <IconButton onClick={handleOpenLogoutDialog} sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { backgroundColor: 'rgba(239,68,68,0.3)' } }}>
                                <LogoutIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
                {menuLayout === 'taskbar' && (
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{ keepMounted: true }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
                        }}
                        anchor="left"
                    >
                        {drawer}
                    </Drawer>
                )}
                <Popover
                    open={Boolean(layoutMenuAnchor)}
                    anchorEl={layoutMenuAnchor}
                    onClose={() => setLayoutMenuAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    PaperProps={{ sx: { backgroundColor: isDarkMode ? '#2b2b2a' : '#ffffff', backgroundImage: 'none', color: isDarkMode ? '#f1f5f9' : '#1B2420', borderRadius: '12px', boxShadow: '0 8px 28px rgba(0,0,0,0.25)' } }}
                >
                    <Box sx={{ p: 0.75, minWidth: 190, color: 'inherit' }}>
                        <Typography sx={{ px: 1.5, py: 0.5, fontSize: '0.7rem', opacity: 0.6, color: 'inherit', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Menu style</Typography>
                        {Object.keys(LAYOUT_LABELS).map((key) => (
                            <Box
                                key={key}
                                onClick={() => { setMenuLayout(key); setLayoutMenuAnchor(null); }}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.9, borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: menuLayout === key ? 700 : 500, color: 'inherit', '&:hover': { backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)' } }}
                            >
                                <CheckIcon sx={{ fontSize: '1rem', visibility: menuLayout === key ? 'visible' : 'hidden' }} />
                                {LAYOUT_LABELS[key]}
                            </Box>
                        ))}
                    </Box>
                </Popover>
                <Dialog
                    open={openLogoutDialog}
                    onClose={handleCloseLogoutDialog}
                    sx={{
                        '& .MuiDialog-paper': {
                            borderRadius: '16px',
                            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
                            overflow: 'hidden',
                            maxWidth: 380,
                            width: '100%',
                            m: 2,
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiBackdrop-root': {
                            backgroundColor: 'rgba(14,42,31,0.45)',
                            backdropFilter: 'blur(4px)',
                        }
                    }}
                >
                    {/* Red top accent */}
                    <Box sx={{ height: 4, background: 'linear-gradient(90deg, #C0392B, #e74c3c)' }} />
                    <DialogContent sx={{ pt: 3.5, pb: 1, px: 3, textAlign: 'center' }}>
                        {/* Icon circle */}
                        <Box sx={{
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(192,57,43,0.1)',
                            border: '2px solid rgba(192,57,43,0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 2,
                        }}>
                            <LogoutIcon sx={{ fontSize: 28, color: '#C0392B' }} />
                        </Box>
                        <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#1B2420', mb: 0.75 }}>
                            Sign Out?
                        </Typography>
                        <Typography sx={{ fontSize: '0.875rem', color: '#5B6660', lineHeight: 1.5 }}>
                            You will be returned to the login screen. Any unsaved changes will be lost.
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1.5 }}>
                        <Button
                            onClick={handleCloseLogoutDialog}
                            fullWidth
                            sx={{
                                color: '#5B6660',
                                border: '1px solid #E6E4DC',
                                backgroundColor: '#F6F5F0',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '10px',
                                py: 1,
                                '&:hover': { backgroundColor: '#EDEBE5' },
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleLogout}
                            fullWidth
                            autoFocus
                            sx={{
                                backgroundColor: '#C0392B',
                                color: '#ffffff',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '10px',
                                py: 1,
                                boxShadow: '0 4px 12px rgba(192,57,43,0.3)',
                                '&:hover': {
                                    backgroundColor: '#a93226',
                                    boxShadow: '0 6px 16px rgba(192,57,43,0.4)',
                                },
                            }}
                        >
                            Yes, Sign Out
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </ThemeProvider>
    );
}

export default ResponsiveDrawer;